/** Content rail width — matches PvP room, TopBar, and BottomNav on wide viewports. */
export const APP_CONTENT_SHELL_CLASSNAME = "mx-auto w-full max-w-2xl" as const
